import editorEvent, { EditorEventName } from '@/editor/event/editorEvent';
import { globalStores } from '@/editor/stores';
import { EEntityType, EOperateMode, ESceneMode } from '@/editor/types';
import { WallRulerController } from './wallRulerController';
import { SepWallRulerController } from './sepWallRulerController';
import { DWRulerController } from './dwRulerController';
import { BoxRulerController } from './boxRulerController';

export class SelectedRulerController {
  private selectedRulerController:
    | WallRulerController
    | SepWallRulerController
    | DWRulerController
    | BoxRulerController
    | null = null;

  private _disposerSet = new Set<() => void>();

  constructor() {
    const updateSelected = this.updateSelected.bind(this);
    this._disposerSet
      .add(editorEvent.on(EditorEventName.ENTITY_SELECTED, updateSelected))
      .add(editorEvent.on(EditorEventName.HISTORY_CHANGE, updateSelected))
      .add(editorEvent.on(EditorEventName.KEYBOARD_PRESS_UPDATE, updateSelected))
      .add(editorEvent.on(EditorEventName.SCENE_MODE_CHANGE, updateSelected))
      .add(editorEvent.on(EditorEventName.REFRESH_SELECTED, updateSelected))
      .add(editorEvent.on(EditorEventName.OPERATE_MODE_CHANGE, updateSelected))
      .add(editorEvent.on(EditorEventName.RESIZE, updateSelected))
      .add(globalStores.editorStateStore.onChange('moving', updateSelected));
  }

  updateSelected() {
    this.clear();

    this._createController();

    if (!this.selectedRulerController) {
      // 没有标尺可重建，残留的聚焦记录会让下次重建出的输入框误聚焦
      globalStores.editorStateStore.resetTextModelFocusData();
    }
  }

  private _createController() {
    if (globalStores.sceneMode !== ESceneMode.scene2d) return;
    if (globalStores.operateInfo.mode !== EOperateMode.EMPTY) return;
    if (globalStores.editorStateStore.moving) return;

    const { selected } = globalStores.editorStateStore;

    if (!selected.entityId) return;

    switch (selected.type) {
      case EEntityType.Wall: {
        this.selectedRulerController = new WallRulerController(selected.entityId);
        this.selectedRulerController.update();
        break;
      }
      case EEntityType.SeparateWall:
        this.selectedRulerController = new SepWallRulerController(selected.entityId);
        this.selectedRulerController.update();
        break;
      case EEntityType.DoorWindow:
        this.selectedRulerController = new DWRulerController(selected.entityId);
        this.selectedRulerController.update();
        break;
      case EEntityType.Column:
        this.selectedRulerController = new BoxRulerController(selected.entityId, EEntityType.Column);
        this.selectedRulerController.update();
        break;
      case EEntityType.Furniture:
        this.selectedRulerController = new BoxRulerController(selected.entityId, EEntityType.Furniture);
        this.selectedRulerController.update();
        break;
      case EEntityType.Assembly:
        this.selectedRulerController = new BoxRulerController(selected.entityId, EEntityType.Assembly);
        this.selectedRulerController.update();
        break;
      case EEntityType.MultiModel:
        globalStores.editorStateStore.refreshFurnitureMultiSelected(); // 更新多选标尺前先刷新多选家具临时数据，因为位置/尺寸可能变了
        this.selectedRulerController = new BoxRulerController(selected.entityId, EEntityType.MultiModel);
        this.selectedRulerController.update();
        break;
      default:
        break;
    }
  }

  clear() {
    if (this.selectedRulerController) {
      this.selectedRulerController.dispose();
    }
    this.selectedRulerController = null;
  }

  dispose() {
    this._disposerSet.forEach((dispose) => dispose());
    this._disposerSet.clear();
  }
}
